import React from 'react';

import Input from './InputWithLabel';

const PasswordGroup = ({
  style,
  password,
  passwordConfirm,
  errorPassword,
  errorPasswordConfirm,
}) => (
  <>
    <Input
      name="password"
      label="Password:"
      type="password"
      styleLabel={style.label}
      styles={style.input}
      {...password}
      error={errorPassword}
    />
    <Input
      name="passwordConfirm"
      label="Confirm Password:"
      type="password"
      styleLabel={style.label}
      styles={style.input}
      {...passwordConfirm}
      error={errorPasswordConfirm}
    />
  </>
);

export default PasswordGroup;
